module.exports = __webpack_public_path__ + "static/img/1402_phase_function_Paper_Points.b058f63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1402_phase_function_Paper_Points.png
// module id = PWLB
// module chunks = 0